// API Helper - Tüm hardcode URL'leri merkezi yapılandırma ile değiştirmek için yardımcı fonksiyonlar
import { getApiUrl, API_ENDPOINTS } from '../config/apiConfig';
import { getCsrfToken, getCachedCsrfToken, setCsrfToken } from './csrfToken';

// Yaygın API çağrıları için hazır fonksiyonlar
export const apiHelper = {
  // Auth işlemleri
  checkAuth: () => fetch(getApiUrl(API_ENDPOINTS.CHECK_AUTH), { credentials: 'include' }),
  login: async (data) => {
    const token = await getCsrfToken();
    const response = await fetch(getApiUrl(API_ENDPOINTS.LOGIN), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    
    // Response'dan token'ı al ve cache'le (eğer varsa)
    // Response'u clone et çünkü json() consume eder
    const clonedResponse = response.clone();
    try {
      const responseData = await clonedResponse.json();
      if (responseData.csrf_token) {
        setCsrfToken(responseData.csrf_token);
      }
    } catch (e) {
      // JSON parse hatası olabilir, önemli değil
    }
    
    return response;
  },
  register: async (data) => {
    const token = await getCsrfToken();
    const response = await fetch(getApiUrl(API_ENDPOINTS.REGISTER), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    
    // Response'dan token'ı al ve cache'le (eğer varsa)
    // Response'u clone et çünkü json() consume eder
    const clonedResponse = response.clone();
    try {
      const responseData = await clonedResponse.json();
      if (responseData.csrf_token) {
        setCsrfToken(responseData.csrf_token);
      }
    } catch (e) {
      // JSON parse hatası olabilir, önemli değil
    }
    
    return response;
  },
  logout: async () => {
    const { clearCsrfToken } = await import('./csrfToken');
    const token = getCachedCsrfToken();
    const response = await fetch(getApiUrl(API_ENDPOINTS.LOGOUT), {
      method: 'POST',
      headers: token ? { 'X-CSRF-Token': token } : {},
      credentials: 'include'
    });
    
    // Logout sonrası token'ı temizle
    clearCsrfToken();
    
    return response;
  },

  // Content işlemleri
  getContent: (params = '') => fetch(`${getApiUrl(API_ENDPOINTS.GET_CONTENT)}${params}`),
  checkContent: () => fetch(getApiUrl(API_ENDPOINTS.CHECK_CONTENT)),
  updateContent: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.UPDATE_CONTENT), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  deleteContent: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.DELETE_CONTENT), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },

  // Episodes & Seasons
  getEpisodes: (params = '') => fetch(`${getApiUrl(API_ENDPOINTS.GET_EPISODES)}${params}`),
  getSeasons: (params = '') => fetch(`${getApiUrl(API_ENDPOINTS.GET_SEASONS)}${params}`),
  addEpisode: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.ADD_EPISODE), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  deleteEpisode: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.DELETE_EPISODE), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  addSeason: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.ADD_SEASON), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  deleteSeason: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.DELETE_SEASON), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  mergeSeasons: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.MERGE_SEASONS), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  addCategory: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.ADD_CATEGORY), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  deleteCategory: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.DELETE_CATEGORY), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  addAlternateTitle: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.ADD_ALTERNATE_TITLE), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },
  deleteAlternateTitle: async (data) => {
    const token = await getCsrfToken();
    return fetch(getApiUrl(API_ENDPOINTS.DELETE_ALTERNATE_TITLE), {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-Token': token
      },
      body: JSON.stringify(data),
      credentials: 'include'
    });
  },

  // User operations
  getUsers: () => fetch(getApiUrl(API_ENDPOINTS.GET_USERS), { credentials: 'include' }),
  getUserProfile: (username) => fetch(`${getApiUrl(API_ENDPOINTS.GET_USER_PROFILE)}?username=${username}`, { credentials: 'include' }),
  
  // Settings
  getSettings: () => fetch(getApiUrl(API_ENDPOINTS.GET_PUBLIC_SETTINGS)),
  
  // Image proxy
  getImageUrl: (path, size = 'w500') => {
    if (!path) return '/placeholder-image.jpg';
    return `${getApiUrl(API_ENDPOINTS.PROXY_IMAGE)}?path=${encodeURIComponent(path)}&size=${size}`;
  }
};

// Eski hardcode URL'leri yeni sistem ile değiştirmek için migration helper
export const replaceHardcodedUrl = (oldUrl) => {
  // Herhangi bir hardcoded API URL'sini tespit et ve yeni sistem ile değiştir
  // Örnek: https://example.com/api/... veya http://localhost/api/...
  const hardcodedPattern = /https?:\/\/[^/]+\/api\//;
  if (hardcodedPattern.test(oldUrl)) {
    const endpoint = oldUrl.replace(hardcodedPattern, '/');
    // endpoint'i API_ENDPOINTS'te bul ve yeni URL'yi döndür
    for (const [key, value] of Object.entries(API_ENDPOINTS)) {
      if (value === endpoint) {
        return getApiUrl(value);
      }
    }
  }
  return oldUrl;
};
